import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import 'animate.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Modal from 'react-modal';
import { store } from "./redux/index"
import { Provider } from 'react-redux';

Modal.setAppElement('#root'); // Replace '#root' with the ID or selector of your root element

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
